import { useMediaQuery } from 'react-responsive'

export const Desktop = ({children}: any) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 })
    return isDesktop ? children : null
};

export const MobileOrTablet = ({ children }: any) => {
    const isMobileOrTablet = useMediaQuery({ maxWidth: 1023 })
    return isMobileOrTablet ? children : null
};
